import { styled, TableCell } from "@mui/material";

export const TableHeaderCell = styled(TableCell)(({ theme }) => ({
  padding: "4px 4px",
  fontWeight: 600,
  // verticalAlign: "top",
  backgroundColor: theme.palette.grey[200],
}));

export const TableRowCell = styled(TableCell)(({ theme }) => ({
  padding: "4px 4px",
}));
